import React from 'react';

import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../../common/input/modal/Modal';
import logoimg from '../../../assets/images/logo.png';
import "./customModalView.scss";

const CustomModalView = (props) => {
	const style1 = {
		"&:hover":{
		"transform": "scale(1.5) !important",
		}
	}
    return (
        <>
            <Modal className="price-calculator-popup" show={props.modal_show} onHide={props.hideCustomModal}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header">
                                        <h4>Alert !!</h4>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div style={{textAlign:"center",padding:'20px'}} className="red-price-box">
                                        <div style={{color:"white"}}> { props.strong_text ? <strong>{props.strong_text}</strong>: null }{ props.h1_text ? <h1>{props.h1_text}</h1>: null }{ props.h5_text ? <h5>{props.h5_text}</h5>: null }<p style={{textAlign: 'justify'}}>{props.authResponse}</p></div>
                                        {props.custom_model ?
                                        <div className="form-btn_group" style={{paddingTop:'0px'}}>
                                              <a href={props.modal_id}><button type="button" className="btn1 btn-default btn-border" > Go To Posted Job<i className="fa fa-folder-open-o" aria-hidden="true"></i></button></a>
                                        </div>
                                         :

                                            null
                                         }

                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default CustomModalView;
